import { useEffect, useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';

// Column
import { PermanentRegCancellationListColumns } from '../../../appconfig/DatatableSetting';

// Data table
import { defaultRowOptions, defaultPageRowOptions, Skeletonitems, SkeletonbodyTemplate, paginatorLinks, showingEntries } from '../../../appconfig/Settings';

import { getAllDetails } from '../../../service/ProductService';
import { PERMANENT_CANCELLED_LIST } from '../../../config/ApiConstant';
import AppBreadcrumb from '../../../components/CustomeBreadcrumb/AppBreadcrumb';
import { ConvertGMTIST } from '../../../appconfig/AppHelper';

export const PermanentRegCancellation = () => {
    document.title = 'Permanent Cancelled Registartion List | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(false);
    const [cancelledList, setCancelledList] = useState<any>([]);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    // useEffect
    useEffect(() => {
        getAllPermanentCancelledList();

        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    // Get all permanent cancelled list
    const getAllPermanentCancelledList = async () => {
        try {
            setPageLoad(false);
            const response = await getAllDetails(PERMANENT_CANCELLED_LIST);
            if (response) {
                const DataList: any = response;
                if (DataList.length === 0) {
                    setCancelledList([]);
                } else {
                    setCancelledList(DataList);
                }
                setPageLoad(true);
            } else {
                setPageLoad(false);
                setCancelledList([]);
            }
        } catch (error: any) {
            setPageLoad(false);
            setCancelledList([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Template for RegCDate
    const RegCDateTemplate = (rowData: any) => {
        return(
            <>
                {!window.cn(rowData.RegCDate) ? ConvertGMTIST(rowData.RegCDate) : ""}
            </>
        )
    };

    // Template for RegCNote
    const RegCNoteTemplate = (rowData: any) => {
        return(
            <>
                <div className="college-name-div">
                    {!window.cn(rowData.RegCNote) ? rowData.RegCNote : ""}
                </div>
            </>
        )
    };

    return(
        <>
            <Toast ref={toast} />
            <AppBreadcrumb currentMenu={'Applications'} pageName={'Permanent Cancelled Registartion List'} pageTitle={'Permanent Cancelled Registartion List'} goToPage={true}/>
            <div className="grid crud-demo">
                <div className="col-12">
                    <div className="card">
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={cancelledList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    rows={defaultRowOptions}
                                    paginator={cancelledList.length >= 10 && true}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    className="datatable-responsive p-datatable-sm"
                                    emptyMessage="No Applications Found"
                                    paginatorTemplate={paginatorLinks}
                                    currentPageReportTemplate={showingEntries}
                                    removableSort
                                >
                                    {PermanentRegCancellationListColumns.map((col, i) => {
                                        if (col.field === 'RegCDate') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={RegCDateTemplate} sortable style={{minWidth:'12rem'}} />;
                                        } else if (col.field === 'RegCNote') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={RegCNoteTemplate}  />;
                                        } else if (col.field === 'SrNo') {
                                            return <Column key={col.field} field={col.field} header={col.header} style={{minWidth:'6rem'}} filter filterPlaceholder={'Search by ' + col.header}  />;
                                        } 
                                        else if (col.field === 'RegNo') {
                                            return <Column key={col.field} field={col.field} header={col.header} style={{minWidth:'7rem'}} filter filterPlaceholder={'Search by ' + col.header}  />;
                                        }  else {
                                            return <Column key={col.field} field={col.field} header={col.header} filter filterPlaceholder={'Search by ' + col.header} />;
                                        }
                                    })}
                                </DataTable>
                                {/* <Paginator first={first} rows={perPage} totalRecords={totalRecords} rowsPerPageOptions={defaultPageRowOptions} onPageChange={onPageChange} /> */}
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {PermanentRegCancellationListColumns.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    )
};